import React from 'react';
import PageSeo from '../components/seo/PageSeo';
import {
  FaEnvelope,
  FaBullhorn,
  FaNewspaper,
  FaCircleExclamation,
  FaInstagram,
  FaYoutube,
  FaFacebookF,
  FaLinkedinIn,
  FaArrowUpRightFromSquare,
  FaClock,
} from 'react-icons/fa6';

import logo from '../img/logo.png';
import '../styles/InfoPage_2.css';

const Contacts = () => {
  return (
    <main className="contacts-page">
      <PageSeo routePath="/contacts" />

      <div className="contacts-container">
        {/* Hero */}
        <section className="contacts-hero">
          <div className="contacts-hero__content">
            <span className="contacts-eyebrow">
              Зв’язок із редакцією
            </span>

            <h1>
              Контакти
              <span>BigSport</span>
            </h1>

            <p>
              Маєте спортивну новину, пропозицію щодо партнерства, рекламний
              запит або помітили неточність у матеріалі? Напишіть нам — ми
              уважно розглядаємо кожне звернення.
            </p>

            <div className="contacts-hero__actions">
              <a
                href="mailto:bigsport.com.ua@gmail.com"
                className="contacts-btn contacts-btn--primary"
              >
                <FaEnvelope />
                Написати редакції
              </a>

              <a
                href="https://www.linkedin.com/company/bigsport"
                target="_blank"
                rel="noopener noreferrer"
                className="contacts-btn contacts-btn--secondary"
              >
                LinkedIn BigSport
                <FaArrowUpRightFromSquare />
              </a>
            </div>
          </div>

          <div className="contacts-hero__visual">
            <div className="contacts-logo-card">
              <div className="contacts-logo-card__glow" />

              <img src={logo} alt="Емблема BigSport" />

              <div className="contacts-logo-card__line" />

              <p>Відкриті до діалогу та співпраці</p>
            </div>
          </div>
        </section>

        {/* Основний контакт */}
        <section className="contacts-section contacts-main-contact">
          <div className="contacts-section-heading">
            <span>Основний канал зв’язку</span>
            <h2>Електронна пошта редакції</h2>

            <p>
              Використовуйте цю адресу для редакційних звернень, співпраці,
              реклами, пресрелізів і повідомлень про помилки.
            </p>
          </div>

          <a
            href="mailto:bigsport.com.ua@gmail.com"
            className="contacts-email-card"
          >
            <div className="contacts-email-card__icon">
              <FaEnvelope />
            </div>

            <div className="contacts-email-card__content">
              <span>Напишіть нам</span>
              <strong>bigsport.com.ua@gmail.com</strong>

              <p>
                Натисніть, щоб відкрити новий лист у вашій поштовій програмі.
              </p>
            </div>

            <FaArrowUpRightFromSquare className="contacts-email-card__arrow" />
          </a>

          <div className="contacts-response-time">
            <FaClock />

            <p>
              Ми намагаємося відповідати на більшість звернень протягом
              <strong> 24–48 годин</strong>.
            </p>
          </div>
        </section>

        {/* Типи звернень */}
        <section className="contacts-section">
          <div className="contacts-section-heading">
            <span>Напрями звернень</span>
            <h2>З якими питаннями можна звертатися</h2>

            <p>
              Щоб ми швидше опрацювали повідомлення, коротко вкажіть тему
              звернення та додайте необхідні матеріали або посилання.
            </p>
          </div>

          <div className="contacts-reasons">
            <article className="contacts-reason-card">
              <div className="contacts-reason-card__icon">
                <FaNewspaper />
              </div>

              <span>01</span>

              <h3>Надіслати новину</h3>

              <p>
                Пресрелізи, анонси матчів і турнірів, офіційні заяви клубів,
                федерацій, спортсменів та організаторів.
              </p>

              <a
                href="mailto:bigsport.com.ua@gmail.com?subject=Новина%20для%20BigSport"
              >
                Надіслати матеріал
                <FaArrowUpRightFromSquare />
              </a>
            </article>

            <article className="contacts-reason-card">
              <div className="contacts-reason-card__icon">
                <FaBullhorn />
              </div>

              <span>02</span>

              <h3>Реклама та партнерство</h3>

              <p>
                Розглядаємо пропозиції щодо рекламних інтеграцій,
                інформаційного партнерства та спільних спортивних проєктів.
              </p>

              <a
                href="mailto:bigsport.com.ua@gmail.com?subject=Співпраця%20з%20BigSport"
              >
                Запропонувати співпрацю
                <FaArrowUpRightFromSquare />
              </a>
            </article>

            <article className="contacts-reason-card">
              <div className="contacts-reason-card__icon">
                <FaCircleExclamation />
              </div>

              <span>03</span>

              <h3>Повідомити про помилку</h3>

              <p>
                Якщо ви помітили неточність, застарілу інформацію або технічну
                проблему, надішліть посилання на відповідну сторінку.
              </p>

              <a
                href="mailto:bigsport.com.ua@gmail.com?subject=Повідомлення%20про%20помилку"
              >
                Повідомити редакцію
                <FaArrowUpRightFromSquare />
              </a>
            </article>
          </div>
        </section>

        {/* Як оформити звернення */}
        <section className="contacts-guide">
          <div className="contacts-guide__brand">
            <img src={logo} alt="BigSport" />
          </div>

          <div className="contacts-guide__content">
            <span>Рекомендації</span>

            <h2>Що додати до повідомлення</h2>

            <div className="contacts-guide__list">
              <div>
                <strong>01</strong>

                <p>
                  Коротку й зрозумілу тему листа.
                </p>
              </div>

              <div>
                <strong>02</strong>

                <p>
                  Опис події, пропозиції або виявленої проблеми.
                </p>
              </div>

              <div>
                <strong>03</strong>

                <p>
                  Посилання, фотографії, документи чи контактні дані.
                </p>
              </div>

              <div>
                <strong>04</strong>

                <p>
                  Бажаний спосіб і термін зворотного зв’язку.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Соцмережі */}
        <section className="contacts-section">
          <div className="contacts-section-heading">
            <span>Офіційні сторінки</span>
            <h2>BigSport у соціальних мережах</h2>

            <p>
              Слідкуйте за новинами, відео та розвитком спортивного
              медіапроєкту на наших офіційних сторінках.
            </p>
          </div>

          <div className="contacts-socials">
            <a
              href="https://www.instagram.com/bigsport.com.ua/"
              target="_blank"
              rel="noopener noreferrer"
              className="contacts-social-card contacts-social-card--instagram"
            >
              <FaInstagram />

              <div>
                <strong>Instagram</strong>
                <span>Новини та спортивний контент</span>
              </div>

              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.youtube.com/@BigSport-TV1"
              target="_blank"
              rel="noopener noreferrer"
              className="contacts-social-card contacts-social-card--youtube"
            >
              <FaYoutube />

              <div>
                <strong>YouTube</strong>
                <span>Відео та спортивні історії</span>
              </div>

              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61587925061004"
              target="_blank"
              rel="noopener noreferrer"
              className="contacts-social-card contacts-social-card--facebook"
            >
              <FaFacebookF />

              <div>
                <strong>Facebook</strong>
                <span>Головні події та публікації</span>
              </div>

              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.linkedin.com/company/bigsport"
              target="_blank"
              rel="noopener noreferrer"
              className="contacts-social-card contacts-social-card--linkedin"
            >
              <FaLinkedinIn />

              <div>
                <strong>LinkedIn</strong>
                <span>Новини та розвиток проєкту</span>
              </div>

              <FaArrowUpRightFromSquare />
            </a>
          </div>
        </section>

        {/* Фінальний CTA */}
        <section className="contacts-cta">
          <div>
            <span>BigSport відкритий до співпраці</span>

            <h2>Розкажіть нам про вашу ідею</h2>

            <p>
              Ми розглядаємо партнерські проєкти, рекламні формати,
              інформаційну співпрацю та матеріали зі світу спорту.
            </p>
          </div>

          <a href="mailto:bigsport.com.ua@gmail.com">
            <FaEnvelope />
            bigsport.com.ua@gmail.com
          </a>
        </section>
      </div>
    </main>
  );
};

export default Contacts;
